import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { setSku } from './productSlice';

import Select from '../../components/BaseSelect';

const CustomOption = ({ selectProps, isSelected, innerProps, data, children }) => {
  let className = `${selectProps.classNamePrefix}__option`;

  if (isSelected) {
    className += ' react-select__option--is-selected';
  }

  return (
    <div className={className} {...innerProps}>
      {children}
    </div>
  );
};

const SingleValue = ({ children, hasValue, getValue, selectProps }) => {
  let className = `${selectProps.classNamePrefix}__single-value`;

  if (!hasValue) {
    return null;
  }

  return (
    <div className={className} style={{ marginTop: -8 }}>
      {children}
    </div>
  );
};

export default function DataPacketSelect() {
  const { selected: selectedNetwork } = useSelector((state) => state.networks);
  const { sku, amount } = useSelector((state) => state.product);

  const dispatch = useDispatch();

  const options = selectedNetwork.dataPackets.find((d) => d.amount === amount);
  const firstSku = options && options.packets.length ? options.packets[0].sku : null;

  useEffect(() => {
    if (firstSku) {
      dispatch(setSku(firstSku));
    }
  }, [dispatch, firstSku]);

  const handleDataPacketChange = (o) => {
    dispatch(setSku(o.sku));
  };

  if (!options || !options.packets.length) {
    return null;
  }

  return (
    <div className="form-group">
      <Select
        value={options.packets
          .map((o) => ({ ...o, label: o.name, value: o.sku }))
          .find((d) => d.sku === sku)}
        onChange={handleDataPacketChange}
        className="data-packet-select"
        options={options.packets.map((o) => ({ ...o, label: o.name, value: o.sku }))}
        components={{ Option: CustomOption, SingleValue }}
        isSearchable={false}
        isDisabled={false}
      />
    </div>
  );
}
